import { render, staticRenderFns } from "./FundingRateHistory.vue?vue&type=template&id=92d3fa6c&scoped=true&"
import script from "./FundingRateHistory.vue?vue&type=script&lang=js&"
export * from "./FundingRateHistory.vue?vue&type=script&lang=js&"
import style0 from "./FundingRateHistory.vue?vue&type=style&index=0&id=92d3fa6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d3fa6c",
  null
  
)

export default component.exports